import { Flex, Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import { Text } from "@chakra-ui/react";
import { UseFormSetValue, Control } from "react-hook-form";
import AddRemoveLineButton from "components/Button/AddRemoveLineButton";
import SelectPerfil from "components/Input/SelectPerfil";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import Field from "components/Input/Field";
import OutlineButton from "ui/components/Button/OutlineButton";
import SelectUsuarioResponsavel from "components/Input/SelectUsuarioResponsavel";

export interface AssinaturasItem {
  pessoaId?: string;
  pessoaNome?: string;
  cargoId?: string;
  cargoNome?: string;
  addTime?: number;
}

interface FormAssinaturasProps {
  control: Control<any>;
  setValue: UseFormSetValue<any>;
  formAssinaturas?: AssinaturasItem[];
  namePrefix?: string;
  title?: string;
}

function FormAssinaturas({
  control,
  setValue,
  formAssinaturas = [],
  namePrefix,
  title = "Assinaturas",
}: FormAssinaturasProps) {
  const { tenant } = useCurrentTenant();
  const onRemove = (index: number) => {
    const copy = [...formAssinaturas];
    copy.splice(index, 1);
    setValue(namePrefix ? `${namePrefix}.assinaturas` : "assinaturas", copy);
  };

  const onAdd = () => {
    const copy = [...formAssinaturas];
    copy.push({
      pessoaId: undefined,
      pessoaNome: undefined,
      cargoId: undefined,
      cargoNome: undefined,
      addTime: new Date().getTime(),
    });
    setValue(namePrefix ? `${namePrefix}.assinaturas` : "assinaturas", copy);
  };

  return (
    <Flex flexDir="column" width="100%">
      <Flex gap={4} my={2} alignItems="center">
        {title ? (
          <Text fontSize={16} fontWeight="bold">
            {title}
          </Text>
        ) : null}
        <OutlineButton onClick={onAdd}>Adicionar assinatura</OutlineButton>
      </Flex>

      {formAssinaturas?.map((item, index) => (
        <Box as={Row} mb="16px" gutter={16} key={item.addTime ?? index}>
          <Box as={Col} xs={11}>
            {index === 0 ? <Text fontSize="13px">Cargo</Text> : null}
            <Field
              control={control}
              name={
                namePrefix
                  ? `${namePrefix}.assinaturas.${index}`
                  : `assinaturas.${index}`
              }
              render={({ field }) => (
                <SelectPerfil
                  tenantId={tenant.id}
                  value={item.cargoId}
                  mode={undefined}
                  placeholder="Selecione um cargo"
                  onChange={(value, option) => {
                    field.onChange({
                      ...item,
                      cargoId: value,
                      cargoNome: (
                        option as unknown as { value: string; label: string }
                      )?.label,
                    });
                  }}
                />
              )}
            />
          </Box>
          <Box as={Col} xs={11}>
            {index === 0 ? <Text fontSize="13px">Nome</Text> : null}
            <Field
              control={control}
              name={
                namePrefix
                  ? `${namePrefix}.assinaturas.${index}`
                  : `assinaturas.${index}`
              }
              render={({ field }) => (
                <SelectUsuarioResponsavel
                  value={item.pessoaId}
                  mode={undefined}
                  placeholder="Selecione uma pessoa"
                  perfilId={item.cargoId}
                  onChange={(value, option) => {
                    field.onChange({
                      ...item,
                      pessoaId: value,
                      pessoaNome: (
                        option as unknown as { value: string; label: string }
                      )?.label,
                    });
                  }}
                />
              )}
            />
          </Box>

          <Box as={Col} xs={2}>
            <AddRemoveLineButton
              showAdd={false}
              onRemove={() => onRemove(index)}
              containerProps={{ mt: index === 0 ? 0 : "-8px" }}
            />
          </Box>
        </Box>
      ))}
    </Flex>
  );
}

export default FormAssinaturas;
